<template>
  <div :class="{ 'cursor-wait': greyOutUI }">
    <div class="no-print">
      <!-- edit stadion-tatjana-01 modal -->
      <modal
        class="no-print"
        name="edit-stadion-tatjana-01-modal"
        :adaptive="true"
        :reset="true"
        height="auto"
        :resizable="true"
        :scrollable="true"
        :focusTrap="true"
        draggable=".window-header"
        @before-close="modalClosed"
      >
        <edit-stadion-tatjana-01
          :selectedItem="selectedItem"
          :isSaveAndProceedButtonVisible="false"
          :statuses="statuses"
          :selectedStatusId="selectedStatusId"
          :employees="employees"
          :isEmployeesVisible="isEmployeesVisible"
          :departments="departments"
          :isStatusesVisible="isStatusesVisible"
          :isDatesVisible="isDatesVisible"
          :title="title"
          @saveAndCloseClicked="editItem"
        />
      </modal>

      <!-- add stadion-tatjana-01 modal -->
      <modal
        class="no-print"
        name="add-stadion-tatjana-01-modal"
        :adaptive="true"
        :reset="true"
        height="auto"
        :resizable="true"
        :scrollable="true"
        :focusTrap="true"
        draggable=".window-header"
        @before-close="modalClosed"
      >
        <edit-stadion-tatjana-01
          :selectedItem="selectedItem"
          :isSaveAndProceedButtonVisible="false"
          :statuses="statuses"
          :selectedStatusId="selectedStatusId"
          :employees="employees"
          :isEmployeesVisible="isEmployeesVisible"
          :departments="departments"
          :isStatusesVisible="isStatusesVisible"
          :isDatesVisible="isDatesVisible"
          :title="title"
          @saveAndCloseClicked="addItem"
        />
      </modal>

      <!-- add private exit modal -->
      <modal
        class="no-print"
        name="add-edit-private-exit-modal"
        :adaptive="true"
        :reset="true"
        height="auto"
        :resizable="true"
        :scrollable="true"
        :focusTrap="true"
        draggable=".window-header"
        @before-close="modalClosed"
      >
        <edit-private-exit
          :selectedItem="selectedItem"
          :isSaveAndProceedButtonVisible="false"
          :statuses="statuses"
          :selectedStatusId="selectedStatusId"
          :employees="employees"
          :isEmployeesVisible="isEmployeesVisible"
          :departments="departments"
          :isStatusesVisible="isStatusesVisible"
          :today="today"
          :tomorrow="tomorrow"
          :title="title"
          @saveAndCloseClicked="addPrivateExit"
        />
      </modal>
    </div>

    <!-- delete stadion-tatjana-01 modal -->
    <modal
      class="no-print"
      name="delete-stadion-tatjana-01-modal"
      :adaptive="true"
      :reset="true"
      :focusTrap="true"
      draggable=".window-header"
    >
      <delete-item
        message="Da li zaista žekite da obrišete slučaj?"
        title="Obriši slučaj"
        :selectedItem="selectedItem"
        @deleteButtonClicked="deleteItemAndResetUi"
      />
    </modal>

    <!-- delete all stadion-tatjana-01 modal -->
    <modal
      class="no-print"
      name="delete-all-stadion-tatjana-01-modal"
      :adaptive="true"
      :reset="true"
      :focusTrap="true"
      draggable=".window-header"
    >
      <delete-item
        message="Da li zaista želite da obrišete SVE slučajeve?"
        title="Obriši slučajeve"
        :selectedItem="deleteAllItemMessage"
        @deleteButtonClicked="deleteAllItems"
      />
    </modal>

    <!-- delete all stadion-tatjana-01 modal -->
    <modal
      class="no-print"
      name="delete-all-unconfirmed-stadion-tatjana-01-modal"
      :adaptive="true"
      :reset="true"
      :focusTrap="true"
      draggable=".window-header"
    >
      <delete-item
        message="Da li zaista želite da obrišete nepotvrđene slučajeve?"
        title="Obriši nepotvrđene slučajeve"
        :selectedItem="deleteAllItemMessage"
        @deleteButtonClicked="deleteAllUnconfirmedItems"
      />
    </modal>

    <!-- toggle late justified modal -->
    <modal
      name="toggle-late-justified-modal"
      :adaptive="true"
      :reset="true"
      height="auto"
      :resizable="true"
      :scrollable="true"
      :focusTrap="true"
      draggable=".window-header"
      @before-close="modalClosed"
    >
      <toggle-late-justified
        title="Vrsta kašnjenja"
        :startDate="today"
        :endDate="tomorrow"
        :selectedDailyLog="selectedDailyLog"
        :isSaveAndProceedButtonVisibl="false"
        @saveAndCloseClicked="changeLateType"
      />
    </modal>

    <!-- Title -->
    <div class="content no-print">
      <h2 class="subtitle">Dnevni izvještaj</h2>
    </div>

    <!-- Tabs -->
    <div class="tabs is-centered is-medium no-print">
      <ul>
        <li :class="{ 'is-active': true }">
          <a>Datum</a>
        </li>
      </ul>
    </div>

    <!-- Time Span -->
    <div class="content no-print" v-show="true">
      <date-picker
        v-model="date"
        @input="dateChosen"
        :disabled-date="disabledTodayAndAfter"
      ></date-picker>
    </div>

    <!-- Absent employees -->
    <p class="no-print">lista odsutnih radnika</p>

    <!-- Absent employees new -->
    <div class="no-print">
      <div v-for="dep in absentEmployeesArranged" v-bind:key="dep.department">
        <p
          class="text"
          v-show="absentEmpsTitleShow(dep)"
          @contextmenu.prevent="absentTitleClicked(dep, $event)"
        >
          {{ dep.department }}
        </p>
        <div class="has-text-left">
          <p
            @drag="drag"
            @contextmenu.prevent="absentEmployeeClicked(emp, $event)"
            @dragend="dragend(emp.id)"
            class="droppable-element flex-child"
            :class="{ coloured: !greyOutUI }"
            draggable="true"
            unselectable="on"
            v-for="emp in dep.absentEmps"
            v-bind:key="emp.id"
          >
            {{ emp.name }}
          </p>
        </div>
      </div>
    </div>

    <!-- Absent employees old -->
    <!-- <div class="flex-container no-print" v-show="true">
      <p
        @drag="drag"
        @contextmenu.prevent="absentEmployeeClicked(emp, $event)"
        @dragend="dragend(emp.id)"
        class="droppable-element flex-child"
        draggable="true"
        unselectable="on"
        v-for="emp in absentEmployees"
        v-bind:key="emp.id"
      >
        {{ emp.name }}
        <span> - </span>
        <span> {{ emp.department }} </span>
      </p>
    </div> -->

    <!-- naslov izvještaja -->
    <div class="has-text-left is-size-10">
      <p>
        Pregled dnevne prisutnosti za
        <span
          ><b>{{ date.toLocaleDateString("sr-latn-cs") }}</b></span
        >
      </p>
    </div>

    <!-- The grid -->
    <div class="is-size-7 printgrid">
      <grid-layout
        :layout.sync="layout"
        :col-num="12"
        :row-height="30"
        :is-draggable="false"
        :is-resizable="false"
        :is-mirrored="false"
        :vertical-compact="true"
        :margin="[10, 10]"
        :use-css-transforms="false"
        :auto-size="true"
        ref="gridlayout"
      >
        <grid-item
          class="janko"
          :class="{ 'vue-grid-item-draggover': item.isDragOver }"
          v-for="item in layout"
          :x="item.x"
          :y="item.y"
          :w="item.w"
          :h="item.h"
          :i="item.i"
          :key="item.i"
          :ref="`item-${item.i}`"
        >
          <div class="text" :ref="`osnovno-${item.i}`">
            <div class="vue-draggable-handle"></div>
            <div class="no-drag">
              <span class="bolded">{{ item.i }}</span>
              <!-- podaci -->
              <div
                class="item-data"
                :class="{
                  active: podatak.hover,
                  notconfirmed: !podatak.isConfirmed,
                }"
                @mouseover="podatak.hover = true"
                @mouseleave="podatak.hover = false"
                v-for="podatak in item.data"
                :key="podatak.i"
              >
                <p>
                  <b @click="itemClicked(podatak)"> {{ podatak.boldText }} </b>
                  <span @click="itemClicked(podatak)">{{ podatak.note }}</span>
                  <span
                    ><b @click="deleteClicked(podatak)" v-show="podatak.hover">
                      ❌
                    </b></span
                  >
                  <span
                    ><b
                      @click="confirmClicked(podatak)"
                      v-show="podatak.hover && !podatak.isConfirmed"
                    >
                      ✅
                    </b></span
                  >
                  <span
                    ><b
                      @click="opravdajOdsustvo(podatak)"
                      v-show="
                        podatak.hover && podatak.gridId === 'Došli na posao'
                      "
                    >
                      ❇️
                    </b></span
                  >
                </p>
              </div>
              <!-- plusić -->
              <div>
                <p
                  class="plus"
                  @mouseover="item.hover = true"
                  @mouseleave="item.hover = false"
                >
                  <span @click="plusClicked(item.i)"> {{ plussign }} </span>
                  <span v-show="item.hover" @click="confirmAllClicked(item)">
                    ✅ potvrdi sve
                  </span>
                  <span
                    v-show="item.hover"
                    @click="deleteAllUnconfirmedClicked(item)"
                  >
                    ❌ obriši nepotvrđeno
                  </span>
                  <span v-show="item.hover" @click="deleteAllClicked(item)">
                    ❌ obriši sve
                  </span>
                </p>
              </div>
            </div>
          </div>
        </grid-item>
      </grid-layout>
    </div>

    <!-- contex menu -->
    <context-menu-max :display="showContextMenu" ref="menu">
      <ul>
        <li
          v-show="showContextMenuDeactivate && !greyOutUI"
          @click="cmSendToNonWorkingDay"
        >
          <p class="cmitem">Neradni dan</p>
        </li>
        <li
          v-show="showContextMenuDeactivateAll && !greyOutUI"
          @click="cmSendAllToNonWorkingDay"
        >
          <p class="cmitem">Svi u neradni dan!</p>
        </li>
      </ul>
    </context-menu-max>

    <!-- test button -->
    <!-- <button class="button" @clshowContextMenuick="testClicked">Test</button> -->

    <!-- spinner -->
    <div class="columns is-mobile" v-show="isLoading">
      <div class="column is-1 is-offset-half">
        <div class="container">
          <div class="has-text-centered">
            <!-- <p>loading...</p> -->
            <p>loading...</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UserService from "../../../services/user.service";
import ReportService from "../../../services/report.service";
import SpecialReportService from "../../../services/specialreport.service";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import EditStadionTatjana01 from "../../parts/EditStadionTatjana01.vue";
import EditPrivateExit from "../../parts/EditPrivateExit.vue";
import ToggleLateJustified from "../../parts/ToggleLateJustified.vue";
import DeleteItem from "../../parts/DeleteItem.vue";
import { GridLayout, GridItem } from "vue-grid-layout";
import ContextMenuMax from "../../parts/ContextMenu.vue";
const { DateTime } = require("luxon");

import {
  // getDepartmentFromEmployeeId,
  removeItemOnce,
  doesArrayContainsObject,
  // getShortTimeFromTicks,
} from "../../../_helpers/arrangers";
// import reportService from "../../../services/report.service";

let mouseXY = { x: null, y: null };
// let DragPos = { x: null, y: null, w: 1, h: 1, i: null };

export default {
  name: "StadionTatjana01",
  components: {
    DatePicker,
    GridLayout,
    GridItem,
    EditStadionTatjana01,
    EditPrivateExit,
    ToggleLateJustified,
    DeleteItem,
    ContextMenuMax,
  },
  data() {
    return {
      greyOutUI: false,
      showContextMenuDeactivateAll: true,
      showContextMenuDeactivate: true,
      showContextMenu: false,
      absentViewAll: false,
      date: new Date(),
      today: new Date(),
      tomorrow: new Date(),
      isLoading: false,
      employees: [],
      plussign: "[+] dodaj",
      absentEmployees: [],
      absentEmployeesAll: [],
      absentEmpoloyeeSelected: null,
      absentEmpTitleSelected: null,
      absentEmployeesArranged: [],
      absentDepartments: [],
      privateEventEmployees: [],
      departments: [],
      statuses: [],
      selectedStatusId: null,
      title: null,
      isStatusesVisible: false,
      isEmployeesVisible: false,
      isDatesVisible: false,
      selectedGridId: null,
      selectedGrid: null,
      userReportId: null,
      selectedItem: {
        boldText: "",
        note: "",
        employeeId: null,
        previewString: "",
      },
      selectedDailyLog: {
        employeeId: null,
        logDate: null,
      },
      deleteAllItemMessage: null,
      layout: [
        {
          x: 0,
          y: 0,
          w: 8,
          h: 1,
          i: "Bolest",
          data: [],
          isDragOver: false,
          hover: false,
          connectedStatusId: 3,
          sRecursive: "R",
        },
        {
          x: 8,
          y: 0,
          w: 4,
          h: 1,
          i: "Slobodan dan",
          data: [],
          isDragOver: false,
          hover: false,
          connectedStatusId: 9,
          sRecursive: "R",
        },
        {
          x: 0,
          y: 1,
          w: 8,
          h: 1,
          i: "Bolovanje",
          data: [],
          isDragOver: false,
          hover: false,
          connectedStatusId: 3,
          sRecursive: "R",
        },
        {
          x: 8,
          y: 1,
          w: 4,
          h: 1,
          i: "Godišnji odmor",
          data: [],
          isDragOver: false,
          hover: false,
          connectedStatusId: 2,
          sRecursive: "R",
        },
        {
          x: 0,
          y: 2,
          w: 12,
          h: 1,
          i: "Trudničko i porodiljsko bolovanje",
          data: [],
          isDragOver: false,
          hover: false,
          connectedStatusId: 10,
          sRecursive: "N",
        },
        {
          x: 0,
          y: 3,
          w: 12,
          h: 1,
          i: "Privatni izlasci tokom radnog vremena",
          data: [],
          isDragOver: false,
          hover: false,
          connectedStatusId: null,
          sRecursive: "N",
        },
        {
          x: 0,
          y: 4,
          w: 12,
          h: 1,
          i: "Došli na posao",
          data: [],
          isDragOver: false,
          hover: false,
          connectedStatusId: null,
          sRecursive: "N",
        },
        {
          x: 0,
          y: 5,
          w: 6,
          h: 1,
          i: "Fakturno - radno vrijeme",
          data: [],
          isDragOver: false,
          hover: false,
          connectedStatusId: null,
          sRecursive: "N",
        },
        {
          x: 0,
          y: 5,
          w: 12,
          h: 1,
          i: "Samoizolacija",
          data: [],
          isDragOver: false,
          hover: false,
          connectedStatusId: 5,
          sRecursive: "R",
        },
        // {
        //   x: 0,
        //   y: 6,
        //   w: 12,
        //   h: 2,
        //   i: "Rad u popodnevnoj smjeni",
        //   data: [],
        //   isDragOver: false,
        //   hover: false,
        //   connectedStatusId: null,
        // },
        {
          x: 6,
          y: 5,
          w: 6,
          h: 1,
          i: "Rad od kuće",
          data: [],
          isDragOver: false,
          hover: false,
          connectedStatusId: 1,
          sRecursive: "R",
        },
        {
          x: 0,
          y: 8,
          w: 12,
          h: 2,
          i: "Tabela za gašenje klime u magacinu i prostoriji za pušače",
          data: [],
          isDragOver: false,
          hover: false,
          connectedStatusId: null,
          sRecursive: "R",
        },
      ],
    };
  },
  mounted() {
    // selected date by default is yesterday
    // console.log("mickey kraljone mounted");

    // console.log(this.date);
    // let yesterday = new Date(this.date).setDate(this.date.getDate() - 1);
    let yesterday = new Date(new Date().getTime() - 24 * 60 * 60 * 1000);
    // console.log("yesterday");
    // console.log(yesterday);

    this.dateChosen(yesterday);
    // this.getDepartments();
    document.addEventListener(
      "dragover",
      function (e) {
        mouseXY.x = e.clientX;
        mouseXY.y = e.clientY;
      },
      false
    );
  },
  updated() {
    // console.log("updated");
    this.resizeAll();
  },
  computed: {},
  methods: {
    disabledTodayAndAfter(date) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      return date >= today;
    },
    absentTitleClicked(dep, event) {
      this.showContextMenuDeactivate = false;
      this.showContextMenuDeactivateAll = true;
      this.absentEmpTitleSelected = dep;
      console.log(this.absentEmpTitleSelected);
      // console.log(dep);
      console.log(event);
      this.$refs.menu.open(event);
    },
    absentEmployeeClicked(emp, event) {
      this.showContextMenuDeactivate = true;
      this.showContextMenuDeactivateAll = false;
      this.absentEmpoloyeeSelected = emp;
      console.log(emp);
      console.log(event);
      this.$refs.menu.open(event);
    },
    cmSendAllToNonWorkingDay() {
      console.log(this.absentEmpTitleSelected);
      console.log("pošaljimo sve u neradni");
      this.greyOutUI = true;
      this.showContextMenu = false;

      this.absentEmpTitleSelected.absentEmps.forEach((absentEmp) => {
        console.log("absentEmp");
        console.log(absentEmp);
        // šaljemo u neradni dan.
        // zapravo napravimo novi report comment u koji stavljamo da
        // je radnik na value2=8 (statusId = SN).
        // To će dalje interno da upiše odgovarajući SN flag u dailylog.
        let data = {
          boldText: absentEmp.name,
          note: "neradni dan",
          employeeId: absentEmp.id,
          isVisible: false,
          statusId: 8,
          sRecursive: "N",
          gridId: null,
          userReportId: 2,
          isConfirmed: true,
        };

        this.postGridItem(data, this.date, null, absentEmp.id);

        // REFACTOR!!!
        // // pošaljimo u neradni dan
        // ReportService.EditDailyLogStatusIdByDateAndEmployeeId(
        //   this.date,
        //   absentEmp.id,
        //   8
        // ).then((rsp) => {
        //   console.log(rsp.statusText);
        // });
      });

      this.$refs.menu.close();

      // reset everything
      this.resetUi(true);
      this.getDepartments();
    },

    cmSendToNonWorkingDay() {
      console.log(this.absentEmpoloyeeSelected);
      console.log("pošaljimo u neradni");

      // status neradnidan
      let data = {
        boldText: this.absentEmpoloyeeSelected.name,
        note: "neradni dan",
        employeeId: this.absentEmpoloyeeSelected.id,
        isVisible: false,
        statusId: 8,
        sRecursive: "N",
        gridId: null,
        userReportId: 2,
        isConfirmed: true,
      };

      this.postGridItem(data, this.date, null, this.absentEmpoloyeeSelected.id);

      // let statusNeradniId =

      // // pošaljimo u neradni dan
      // ReportService.EditDailyLogStatusIdByDateAndEmployeeId(
      //   this.date,
      //   this.absentEmpoloyeeSelected.id,
      //   8
      // ).then((rsp) => {
      //   console.log(rsp.statusText);
      // });

      this.$refs.menu.close();

      // reset everything
      this.resetUi(true);
      this.getDepartments();
    },
    drag() {
      this.layout.forEach((element) => {
        if (this.isMouseInGrid(element.i)) {
          element.isDragOver = true;
          this.selectedGridId = element.i;
          console.log("hit " + element.i);
        } else element.isDragOver = false;
      });
    },
    isMouseInGrid(itemId) {
      let gridItemComponent = this.$refs[`item-${itemId}`][0].$el;
      let childRect = gridItemComponent.getBoundingClientRect();

      let mouseInGrid = false;
      if (
        mouseXY.x > childRect.left &&
        mouseXY.x < childRect.right &&
        mouseXY.y > childRect.top &&
        mouseXY.y < childRect.bottom
      ) {
        mouseInGrid = true;
      }
      return mouseInGrid;
    },
    dragend(employeeId) {
      // console.log(this.selectedGridId);
      // console.log(employeeId);
      let myGridItem = this.layout.find((l) => l.i == this.selectedGridId);
      this.selectedItem = {
        employeeId: employeeId,
      };
      this.plusClicked(this.selectedGridId);
      // console.log(myGridItem);
      // console.log(this.layout);

      myGridItem.isDragOver = false;
    },
    changeLateType(t) {
      console.log(t);
      this.$modal.hide("toggle-late-justified-modal");
    },

    resetUi(total = false) {
      console.log("resetUi");
      // this.greyOutUI = false;
      this.selectedItem = {
        boldText: "",
        note: "",
        employeeId: null,
        previewString: "",
      };
      // this.selectedGridId = null;
      this.selectedGrid = null;

      if (total) {
        this.employees = [];
        this.absentEmployees = [];
        this.privateEventEmployees = [];
        this.layout = [
          {
            x: 0,
            y: 0,
            w: 8,
            h: 1,
            i: "Bolest",
            data: [],
            isDragOver: false,
            hover: false,
            connectedStatusId: 3,
            sRecursive: "R",
          },
          {
            x: 8,
            y: 0,
            w: 4,
            h: 1,
            i: "Slobodan dan",
            data: [],
            isDragOver: false,
            hover: false,
            connectedStatusId: 5,
            sRecursive: "R",
          },
          {
            x: 0,
            y: 1,
            w: 8,
            h: 1,
            i: "Bolovanje",
            data: [],
            isDragOver: false,
            hover: false,
            connectedStatusId: 3,
            sRecursive: "R",
          },
          {
            x: 8,
            y: 1,
            w: 4,
            h: 1,
            i: "Godišnji odmor",
            data: [],
            isDragOver: false,
            hover: false,
            connectedStatusId: 2,
            sRecursive: "R",
          },
          {
            x: 0,
            y: 2,
            w: 12,
            h: 1,
            i: "Trudničko i porodiljsko bolovanje",
            data: [],
            isDragOver: false,
            hover: false,
            connectedStatusId: 10,
            sRecursive: "R",
          },
          {
            x: 0,
            y: 3,
            w: 12,
            h: 1,
            i: "Privatni izlasci tokom radnog vremena",
            data: [],
            isDragOver: false,
            hover: false,
            connectedStatusId: null,
            sRecursive: "N",
          },
          {
            x: 0,
            y: 4,
            w: 12,
            h: 1,
            i: "Došli na posao",
            data: [],
            isDragOver: false,
            hover: false,
            connectedStatusId: null,
            sRecursive: "N",
          },
          {
            x: 0,
            y: 5,
            w: 6,
            h: 1,
            i: "Fakturno - radno vrijeme",
            data: [],
            isDragOver: false,
            hover: false,
            connectedStatusId: null,
            sRecursive: "N",
          },
          {
            x: 0,
            y: 5,
            w: 12,
            h: 1,
            i: "Samoizolacija",
            data: [],
            isDragOver: false,
            hover: false,
            connectedStatusId: 5,
            sRecursive: "R",
          },
          // {
          //   x: 0,
          //   y: 6,
          //   w: 12,
          //   h: 2,
          //   i: "Rad u popodnevnoj smjeni",
          //   data: [],
          //   isDragOver: false,
          //   hover: false,
          //   connectedStatusId: null,
          // },
          {
            x: 6,
            y: 5,
            w: 6,
            h: 1,
            i: "Rad od kuće",
            data: [],
            isDragOver: false,
            hover: false,
            connectedStatusId: 1,
            sRecursive: "R",
          },
          {
            x: 0,
            y: 8,
            w: 12,
            h: 1,
            i: "Tabela za gašenje klime u magacinu i prostoriji za pušače",
            data: [],
            isDragOver: false,
            hover: false,
            connectedStatusId: null,
            sRecursive: "R",
          },
        ];
      }
    },
    employeeFromId(id) {
      return this.employees.find((x) => x.id === id).name;
    },
    // GetEmployeeWorkhoursDataByDateAndDepartmentId() {
    //   // Ako među fakturnom postoji radnik sa tim id, edituj ga
    //   reportService
    //     .GetEmployeeWorkhoursDataByDateAndDepartmentId(
    //       this.today,
    //       this.tomorrow,
    //       43
    //     )
    //     .then((response) => {
    //       let myFakturnoData = response.data;
    //       console.log("myFakturnoData");
    //       console.log(myFakturnoData);

    //       myFakturnoData.forEach((emp) => {
    //         // add to table
    //         let at = "";
    //         let dt = "";
    //         if (
    //           emp.arrivalTimeGeneral == null ||
    //           emp.departureTimeGeneral == null
    //         ) {
    //           at = "odsutna";
    //         } else {
    //           at = emp.arrivalTimeGeneral.split("T")[1];
    //           dt = emp.departureTimeGeneral.split("T")[1];
    //         }
    //         let data = {
    //           boldText: emp.name,
    //           note:
    //             at +
    //             " - " +
    //             dt +
    //             "; ukupno: " +
    //             getShortTimeFromTicks(emp.duration),
    //           employeeId: emp.employeeId,
    //           gridId: "Fakturno - radno vrijeme",
    //           userReportId: this.userReportId,
    //           hover: false,
    //           isConfirmed: true,
    //         };

    //         console.log("papak");
    //         console.log(data);

    //         this.addDataToGridItem("Fakturno - radno vrijeme", data);
    //       });
    //     });
    // },
    // getPrivatePedestrianEventsByDate() {
    //   console.log("ĐO");
    //   ReportService.GetPrivatePedestrianEventsByDate(
    //     this.today,
    //     this.tomorrow
    //   ).then((response) => {
    //     response.data.forEach((element) => {
    //       console.log(response.data);
    //       this.privateEventEmployees.push({
    //         id: element.employeeId,
    //         name: element.name,
    //         department: getDepartmentFromEmployeeId(
    //           this.$store.state.general.departmentData,
    //           element.employeeId
    //         ),
    //         arivalTime: element.arivalTime,
    //         departureTime: element.departureTime,
    //         duration: element.duration,
    //       });
    //     });
    //     console.log("this.privateEventEmployees");
    //     console.log(this.privateEventEmployees);

    //     // add to table
    //     this.privateEventEmployees.forEach((emp) => {
    //       let data = {
    //         boldText: emp.name,
    //         note:
    //           emp.departureTime.split("T")[1] +
    //           " - " +
    //           emp.arivalTime.split("T")[1] +
    //           "; ukupno: " +
    //           getShortTimeFromTicks(emp.duration),
    //         employeeId: emp.employeeId,
    //         gridId: "Privatni izlasci tokom radnog vremena",
    //         userReportId: this.userReportId,
    //         hover: false,
    //         isConfirmed: true,
    //       };

    //       this.addDataToGridItem("Privatni izlasci tokom radnog vremena", data);
    //     });
    //   });
    // },

    getAbsentEmployeesByDate() {
      ReportService.GetAbsentEmployeesByDateExceptStadionLogistika(
        this.today,
        this.tomorrow
      ).then((response) => {
        response.data.forEach((element) => {
          if (
            this.absentEmployees.findIndex(
              (emp) => emp.id === element.employeeId
            ) === -1
          ) {
            this.absentEmployees.push({
              id: element.employeeId,
              name: element.firstName + " " + element.lastName,
              department: element.departmentName,
            });
          }
        });
        this.absentEmployeesAll = [];
        this.absentEmployees.forEach((ae) => {
          this.absentEmployeesAll.push(ae);
        });
        // rearange absent employees
        this.rearangeAbsentEmployees();
        // get reports from database
        this.getReport();
      });
    },
    rearangeAbsentEmployees() {
      // reset
      this.absentDepartments = [];
      this.absentEmployeesArranged = [];

      // fill departments
      this.absentEmployees.forEach((absemp) => {
        let depExists = doesArrayContainsObject(absemp, this.absentDepartments);
        console.log("absemp.department");
        if (!depExists) {
          this.absentDepartments.push(absemp.department);
          console.log(absemp.department);
        }
      });

      // Form absent employeesArranged sa ovim podacima
      console.log("ABSDEOO");
      console.log(this.absentDepartments);

      this.absentDepartments.forEach((absdep) => {
        this.absentEmployeesArranged.push({
          department: absdep,
          absentEmps: [],
        });
      });

      // fill absentEmps ind absentEmployesArranged
      this.absentEmployees.forEach((emp) => {
        let myAbEmpArr = this.absentEmployeesArranged.find(
          (e) => e.department === emp.department
        );
        myAbEmpArr.absentEmps.push(emp);
      });

      console.log("ABSDEP");
      console.log(this.absentEmployeesArranged);
    },

    getReport() {
      this.isLoading = true;
      // First recalculate private entrances
      SpecialReportService.StadionRecalculateCameToWorkAndWriteToReportCommentByDate(
        this.today
      ).then(() => {
        SpecialReportService.StadionRecalculateFakturnoAndWriteToReportCommentByDate(
          this.today
        ).then(() => {
          // then recalculate fakturno radni sati
          SpecialReportService.StadionRecalculatePrivateEventsAndWriteToReportCommentByDate(
            this.today
          ).then(() => {
            // then get reports from reportComment table in db
            SpecialReportService.GetDailyReport01ByDate(this.today).then(
              (response) => {
                this.isLoading = false;
                console.log("BROJ 26");
                console.log(response.data);
                let pristigliReporti = response.data;

                this.arrangeData(pristigliReporti);

                // ako je radnik prisutan, izbriši report osim za fakturno radno vrijeme, privatne izlaske i rad od kuće.
                // to jest osim onima kojima connectedStatusId = null. To se odnosi samo na reportcomment-e koji nisu confirmed.
                // - da li je radnik prisutan znamo na osnovu liste this.absentEmployeesAll. Tj onaj koji se
                // ne nalazi u ovoj listi je prisutan.
                // To znači da moramo da prođemo kroz svaki reportComent. ReportCommenti se nalaze u nizu
                // foreach this.layout, pa foreach data.
                console.log("BROJ 1");
                this.greyOutUI = false;
                this.showContextMenu = true;

                let reportCommentsToDelete = [];
                this.layout.forEach((element) => {
                  // brišemo samo za ona polja koji imaju connectedStatusId
                  // console.log("element i");
                  // console.log(element.i);
                  if (
                    element.connectedStatusId &&
                    element.i !== "Rad od kuće"
                  ) {
                    // console.log(element.i);
                    element.data.forEach((data) => {
                      // console.log(data);
                      // console.log("absent employees:");
                      // console.log(this.absentEmployees);
                      // console.log("absent employees all:");
                      // console.log(this.absentEmployeesAll);
                      // console.log(reportCommentsToDelete);

                      // da li se zaposleni (data.employeeId) nalazi u this.absentEmployeesAll?
                      let absent = this.absentEmployeesAll.find(
                        (ae) => ae.id === data.employeeId
                      );
                      if (typeof absent === "undefined") {
                        console.log("ipak prisutan:");
                        console.log(data);
                        if (!data.isConfirmed) {
                          reportCommentsToDelete.push(data);
                        }
                      }

                      // ReportComment se briše po ReportCommentId
                    });
                  } else {
                    console.log("SKIP!");
                  }
                });

                // pronašli smo sve radnike koji su ipak prisutni. Izbrišimo odgovarajuće report commente.
                let found = false;
                reportCommentsToDelete.forEach((rc) => {
                  SpecialReportService.DeleteReport01(rc).then((response) =>
                    console.log(response.data)
                  );
                  found = true;
                });

                // reset everything
                if (found) {
                  this.resetUi(true);
                  this.getDepartments();
                }
              }
            );
          });
        });
      });
    },

    getDepartments() {
      UserService.getDepartmentsExceptStadionLogistika().then((response) => {
        // reset ui
        // console.log(response.data);
        this.departmentData = response.data;
        this.arrangeSectors(response.data);
        this.arrangeEmployees(response.data);
        this.getStatuses();
      });
    },
    arrangeSectors(data) {
      data.forEach((element) => {
        this.departments.push({
          name: element.name,
          id: element.departmentId,
        });
      });
      // console.log(this.departments);
    },
    getStatuses() {
      ReportService.GetStatuses().then((response) => {
        this.statuses = response.data;
        // console.log(this.statuses);
        // let ndx = 1;
        console.log("rows");
        response.data.forEach((element) => {
          console.log(element);
        });
        this.getAbsentEmployeesByDate();
        // this.getPrivatePedestrianEventsByDate();
        // this.GetEmployeeWorkhoursDataByDateAndDepartmentId();

        // this.getAbsentEmployees();
      });
    },
    dateChosen(date) {
      console.log(date);
      this.date = date;
      this.today = date;
      // console.log("dateChosen");
      // console.log(this.today);

      let nextDay1 = new Date(this.today);
      nextDay1.setDate(this.today.getDate() + 1);
      this.tomorrow = nextDay1;
      // console.log(this.tomorrow);
      this.today.setHours(0, 0, 0, 0);
      this.tomorrow.setHours(0, 0, 0, 0);

      this.resetUi(true);
      this.getDepartments();
    },
    arrangeData(data) {
      data.forEach((element) => {
        // console.log("Šta ima vodje?");
        // console.log(element);

        let gridId = element.titleProperties;
        let boldText = element.title;
        let note = element.paragraph;
        let isConfirmed = element.isConfirmed;
        let employeeId = element.value1;
        let statusId = element.value2;
        let sRecursive = element.string1;
        let reportcommentId = element.reportcommentId;

        this.userReportId = element.userReportId;

        this.addDataToGridItem(gridId, {
          reportcommentId: reportcommentId,
          boldText: boldText,
          note: note,
          employeeId: employeeId,
          gridId: gridId,
          statusId: statusId,
          sRecursive: sRecursive,
          userReportId: this.userReportId,
          hover: false,
          isConfirmed: isConfirmed,
        });

        // izbrisati item iz obične liste
        // console.log("Šta ima ovdje");
        // console.log(sRecursive);
        if (statusId !== null) {
          this.absentEmployees = removeItemOnce(
            this.absentEmployees,
            employeeId
          );

          // izbrisati item iz liste absentEmployeesArranged
          this.absentEmployeesArranged.forEach((aba) => {
            // run throuhg aba.absentEmp
            aba.absentEmps = removeItemOnce(aba.absentEmps, employeeId);
          });
          // this.absentEmployeesArranged.find((aea) => aea.department === t);
        }
      });
    },
    arrangeEmployees(data) {
      data.forEach((element) => {
        element.employee.forEach((emp) => {
          if (!emp.status) return;
          this.employees.push({
            name: emp.firstName + " " + emp.lastName,
            id: emp.employeeId,
            departmentName: this.departments.find(
              (d) => d.id === emp.departmentId
            ).name,
          });
        });
      });
    },
    testClicked() {
      // console.log("o");
      this.resizeAll();
    },

    opravdajOdsustvo(item) {
      console.log(item);
      var luxonDate = DateTime.fromJSDate(this.today);
      var today = luxonDate.toISO().split("+")[0];
      this.selectedDailyLog = { employeeId: item.employeeId, logDate: today };
      this.$modal.show("toggle-late-justified-modal");
    },

    addPrivateExit(exit) {
      console.log("Exit is: ", exit);
      if (!exit.isFallback) {
        // poslat je izlazak koji treba pretvoriti u privatni
        console.log("Private exit to add ", exit);
        this.sendRemoteData(exit);
      } else {
        // ne postoji izlazak koji treba pretvoriti u privatni
        console.log("PAPAGAJ RANKO");
        this.addItem(exit.selectedItem);
      }
      this.$modal.hide("add-edit-private-exit-modal");
    },

    sendRemoteData(exit) {
      console.log("hic!!!");

      // calculate data
      const dailyLog = exit.selectedDailyLog;
      const outsideEvent = exit.selectedOutsideEvent;

      console.log("dailyLog: ", dailyLog);
      console.log("outsideEvent: ", outsideEvent);

      const affectedAccessLogs = [];

      dailyLog.myAccessLogs.forEach((al) => {
        if (al.accessTime === outsideEvent.departureTime) {
          affectedAccessLogs.push(al);
        }
      });

      console.log("affected logs: ", affectedAccessLogs);

      affectedAccessLogs.forEach((aal) => {
        const accessId = 902; // Privatni izlazak
        switch (aal.sender) {
          case "mifare":
            console.log("tip: mifare!");
            ReportService.EditAccessLogChoiceIdByEmployeeIdAndAccessTimeAndCheckpointId(
              aal.employeeId,
              aal.accessTime,
              aal.checkpointId,
              accessId
            ).then((response) => {
              console.log(response.data);
              ReportService.GetNormalizedAccessDataByTimeRange(
                this.today,
                this.tomorrow,
                aal.employeeId,
                null
              ).then((response) => {
                console.log(response);
                this.resetUi(true);
                this.getDepartments();
              });
            });
            break;
          case "cam":
            ReportService.EditAccessCameraChoiceIdByAccessRemoteId(
              aal.correspondingLogId,
              accessId
            ).then((response) => {
              console.log(response.data);
              ReportService.GetNormalizedAccessDataByTimeRange(
                this.today,
                this.tomorrow,
                aal.employeeId,
                null
              ).then((response) => {
                console.log(response);
                this.resetUi(true);
                this.getDepartments();
              });
            });
            break;
          case "uhf":
            console.log("tip: uhf");
            ReportService.EditAccessUhfChoiceIdByAccessRemoteId(
              aal.correspondingLogId,
              accessId
            ).then((response) => {
              console.log(response.data);
              ReportService.GetNormalizedAccessDataByTimeRange(
                this.today,
                this.tomorrow,
                aal.employeeId,
                null
              ).then((response) => {
                console.log(response);
                this.resetUi(true);
                this.getDepartments();
              });
            });
            break;
          case "remote":
            console.log("tip: remote");
            ReportService.EditAccessRemoteChoiceIdByAccessRemoteId(
              aal.correspondingLogId,
              accessId
            ).then((response) => {
              console.log(response);
              ReportService.GetNormalizedAccessDataByTimeRange(
                this.today,
                this.tomorrow,
                aal.employeeId,
                null
              ).then((response) => {
                console.log(response);
                this.resetUi(true);
                this.getDepartments();
              });
            });
            break;
          default:
            console.log("unknown type!");
            break;
        }
      });
    },

    resizeAll() {
      this.layout.forEach((element) => {
        let itemY = this.resizeItem(element.i);
        if (itemY !== -1) {
          let itemsFromSameRow = this.getAllGridItemsFromSameRow(itemY);
          // force resize all of them
          // console.log("itemsFromSameRow");
          // console.log(itemsFromSameRow);
          itemsFromSameRow.forEach((item) => {
            this.resizeItem(item.i, true, element.h);
          });
        }
      });
    },
    getAllGridItemsFromSameRow(itemY) {
      let itemsFromSameRow = [];

      this.layout.forEach((element) => {
        if (element.y === itemY) {
          itemsFromSameRow.push(element);
        }
      });

      return itemsFromSameRow;
    },
    resizeItem(itemId, forceResize = false, itemH) {
      let gridLayoutComponent = this.$refs["gridlayout"];
      let gridItemComponent = this.$refs[`item-${itemId}`][0];
      let innerItemComponent = this.$refs[`osnovno-${itemId}`][0];

      // console.log("gridItemcomponent");
      // console.log(gridItemComponent);
      // console.log("innerItemComponent");
      // console.log(innerItemComponent);

      let itemLayoutParam = this.layout.find((obj) => obj.i === itemId);
      // console.log(itemLayoutParam);

      // console.log("visina lyaout objekta:");
      let visinaLayout = gridItemComponent.$el.clientHeight;
      // console.log(visinaLayout);
      // console.log("visina samog objekta:");
      // visina = gridItemComponent.$el;
      // console.log(visina);
      let visinaInner = innerItemComponent.clientHeight;
      // console.log(visinaInner);

      let layoutParams = { ...itemLayoutParam };

      let doResize = false;
      if (visinaInner + 15 > visinaLayout) {
        doResize = true;
      }

      // if (layoutParams.h === 2) {
      //   gridItemComponent.innerH = 4;
      //   layoutParams.h = 4;
      //   itemLayoutParam.showText = true;
      // } else {
      //   gridItemComponent.innerH = 2;
      //   layoutParams.h = 2;
      //   itemLayoutParam.showText = false;
      // }
      let resizedY = -1;

      if (doResize) {
        layoutParams.h++;
        resizedY = layoutParams.y;

        gridLayoutComponent.resizeEvent(
          "resizeend",
          itemId,
          layoutParams.x,
          layoutParams.y,
          layoutParams.h,
          layoutParams.w
        );
      }

      if (forceResize) {
        layoutParams.h = itemH;
        resizedY = layoutParams.y;

        gridLayoutComponent.resizeEvent(
          "resizeend",
          itemId,
          layoutParams.x,
          layoutParams.y,
          layoutParams.h,
          layoutParams.w
        );
      }

      return resizedY;
    },
    addItem(item) {
      console.log("HIC!!! Item");
      console.log(this.selectedGrid);
      console.log(this.selectedItem);
      console.log(item);
      let data = {
        boldText: item.boldText,
        note: item.note,
        employeeId: item.employeeId,
        statusId: this.layout.find((l) => l.i === this.selectedGridId)
          .connectedStatusId,
        sRecursive: this.layout.find((l) => l.i === this.selectedGridId)
          .sRecursive,
        gridId: this.selectedGridId,
        userReportId: this.userReportId,
        hover: false,
        isConfirmed: true,
      };

      this.addDataToGridItem(this.selectedGridId, data);

      this.postGridItem(data, this.date, this.selectedGridId, item.employeeId);

      // remove this employee from the list of absent employees
      this.absentEmployees = removeItemOnce(
        this.absentEmployees,
        item.employeeId
      );
      // izbrisati item iz liste absentEmployeesArranged
      this.absentEmployeesArranged.forEach((aba) => {
        // run throuhg aba.absentEmp
        aba.absentEmps = removeItemOnce(aba.absentEmps, item.employeeId);
      });

      this.$modal.hide("add-stadion-tatjana-01-modal");

      this.resetUi();
    },
    addDataToGridItem(i, data) {
      if (i) {
        let myGridItem = this.layout.find((l) => l.i === i);

        if (!myGridItem) {
          console.warn(`Grid item "${i}" not found in layout`);
          return;
        }

        myGridItem.data.push(data);

        this.resizeAll();
      }
    },
    postGridItem(gridItemData, date, i, employeeId) {
      console.log("AVET");
      console.log(gridItemData);
      console.log(date);
      SpecialReportService.PostDailyReport01(gridItemData, date, i).then(
        (response) => {
          // console.log(response.data);
          if (response.data !== "already exists")
            gridItemData.reportcommentId = response.data;
          console.log(employeeId);
          // Ovo treba da se stavi u neki niz pa polako jedan po jedan da se riješe (U slučaju slanja gomile ljudi u "SN")
          ReportService.GetNormalizedAccessDataByTimeRange(
            this.today,
            this.tomorrow,
            employeeId,
            null
          );
        }
      );
    },
    // addItemAndContinue(item) {
    //   let data = {
    //     boldText: item.boldText,
    //     note: item.note,
    //     employeeId: item.employeeId,
    //     gridId: this.selectedGridId,
    //     userReportId: this.userReportId,
    //   };

    //   this.addDataToGridItem(this.selectedGridId, data);

    //   // console.log("mickey kraljone addItemAndContinue");
    //   // console.log(this.date);

    //   this.postGridItem(data, this.date, this.selectedGridId);

    //   // remove this employee from the list of absent employees
    //   this.absentEmployees = removeItemOnce(
    //     this.absentEmployees,
    //     item.employeeId
    //   );
    //   // izbrisati item iz liste absentEmployeesArranged
    //   this.absentEmployeesArranged.forEach((aba) => {
    //     // run throuhg aba.absentEmp
    //     aba.absentEmps = removeItemOnce(aba.absentEmps, item.employeeId);
    //   });

    //   this.resetUi();
    // },
    editItem(item) {
      // console.log("edited item:");
      // console.log(item);
      // console.log("Papagaj");
      // console.log(this.selectedGridId);

      // console.log("mickey kraljone editItem");
      // console.log(this.date);
      console.log("HIC 44");
      console.log(item);

      SpecialReportService.EditDailyReport01(
        item,
        this.date,
        this.selectedGridId
      ).then((response) => {
        console.log(response);
      });

      this.$modal.hide("edit-stadion-tatjana-01-modal");
    },
    // calculateNote(item) {
    //   // find connected status description
    //   let myGridItem = this.layout.find((l) => l.i == this.selectedGridId);
    //   let myConnectedStatusId = myGridItem.connectedStatusId;
    //   let note = "";
    //   if (myConnectedStatusId !== null) {
    //     // add status description to note..
    //     let statusDesc = this.statuses.find(
    //       (s) => s.statusId === myGridItem.connectedStatusId
    //     ).description;

    //     note += statusDesc + " ";
    //   }

    //   // add item's note to it.
    //   note += item.note;
    //   return note;
    // },
    deleteAllItems() {
      console.log(this.selectedGrid);
      this.$modal.hide("delete-all-stadion-tatjana-01-modal");

      this.selectedGrid.data.forEach((element) => {
        this.deleteItem(element);
      });

      // reset everything
      this.resetUi(true);
      this.getDepartments();
    },
    deleteAllUnconfirmedItems() {
      console.log(this.selectedGrid);
      this.$modal.hide("delete-all-unconfirmed-stadion-tatjana-01-modal");

      this.selectedGrid.data.forEach((element) => {
        if (element.isConfirmed === false) {
          this.deleteItem(element);
        }
      });

      // reset everything
      this.resetUi(true);
      this.getDepartments();
    },
    deleteItemAndResetUi() {
      this.$modal.hide("delete-stadion-tatjana-01-modal");

      this.deleteItem(this.selectedItem);

      // reset everything
      this.resetUi(true);
      this.getDepartments();
    },
    deleteItem(itemToDelete) {
      console.log("DELETE ITEM:");
      console.log(itemToDelete);
      // let myNumber = itemToDelete.employeeId;
      SpecialReportService.DeleteReport01(itemToDelete).then(() => {});
    },
    plusClicked(id) {
      if (id !== null) {
        if (id == "Privatni izlasci tokom radnog vremena") {
          console.log("Bingo!!");
          this.selectedGridId = id;
          this.title = "dodaj novi privatni izlazak";
          this.isStatusesVisible = false;
          this.isEmployeesVisible = true;
          this.selectedStatusId = this.layout.find(
            (l) => l.i === id
          ).connectedStatusId;
          console.log("HIC Selected Status Id");
          console.log(this.selectedStatusId);
          this.isDatesVisible = false;
          this.$modal.show("add-edit-private-exit-modal");
          return;
        }
        this.selectedGridId = id;
        this.title = "dodaj novi slučaj u: " + id;
        this.isStatusesVisible = false;
        this.isEmployeesVisible = true;
        this.selectedStatusId = this.layout.find(
          (l) => l.i === id
        ).connectedStatusId;
        console.log("HIC Selected Status Id");
        console.log(this.selectedStatusId);
        if (id == "Tabela za gašenje klime u magacinu i prostoriji za pušače") {
          this.isEmployeesVisible = false;
        }
        this.isDatesVisible = false;
        this.$modal.show("add-stadion-tatjana-01-modal");
      }
    },
    modalClosed() {
      this.resetUi();
    },

    absentEmpsTitleShow(dep) {
      // console.log("JEDAN");
      // console.log(dep);
      if (dep.absentEmps.length === 0) {
        return false;
      } else return true;
    },

    itemClicked(item) {
      // console.log(item);

      this.selectedItem = item;
      this.selectedGridId = item.gridId;
      this.title = "izmijeni slučaj u: " + item.gridId;
      this.selectedStatusId = this.layout.find(
        (l) => l.i === item.gridId
      ).connectedStatusId;
      this.isStatusesVisible = false;
      this.isEmployeesVisible = true;
      if (
        item.gridId ==
        "Tabela za gašenje klime u magacinu i prostoriji za pušače"
      ) {
        this.isEmployeesVisible = false;
      }
      this.isDatesVisible = false;

      this.$modal.show("edit-stadion-tatjana-01-modal");
    },
    deleteAllUnconfirmedClicked(grid) {
      this.selectedGrid = grid;
      this.deleteAllItemMessage = {
        firstName: "obrisati",
        lastName: "nepotvrđene elemente",
      };
      this.$modal.show("delete-all-unconfirmed-stadion-tatjana-01-modal");
    },
    deleteAllClicked(grid) {
      this.selectedGrid = grid;
      this.deleteAllItemMessage = {
        firstName: "obrisati",
        lastName: "sve",
      };
      this.$modal.show("delete-all-stadion-tatjana-01-modal");
    },
    deleteClicked(item) {
      this.selectedItem = item;
      this.$modal.show("delete-stadion-tatjana-01-modal");
    },
    confirmAllClicked(item) {
      item.data.forEach((element) => {
        if (element.isConfirmed === false) {
          this.confirmClicked(element);
        }
      });
    },
    confirmClicked(item) {
      item.isConfirmed = true;
      this.selectedGridId = item.gridId;

      // console.log("mickey kraljone confirmClicked");
      // console.log(this.date);

      SpecialReportService.EditDailyReport01(
        item,
        this.date,
        this.selectedGridId
      ).then((response) => {
        console.log(response.statusText);
      });
    },
  },
};
</script>

<style>
.printgrid {
  width: 1000px;
  margin: 0;
  /* float: none; */
}
.vue-grid-layout {
  /* max-width: 210mm; */
  background-color: #f1d4d4;
}
.vue-grid-item {
  border: 1px solid #f36886;
  display: flex;
  flex-direction: column;
  justify-content: top;
  align-content: left;
  align-items: left;
}
.plus {
  /* border: 1px solid #f36886; */
  display: flex;
  flex-direction: row;
  justify-content: top;
  align-items: left;
  color: darkblue;
  text-decoration: underline;
  cursor: pointer;
  margin-left: 10px;
}
/**
 * Print Stylesheet fuer Deinewebsite.de
* @version         1.0
* @lastmodified    16.06.2016
*/

@media print {
  /* Inhaltsbreite setzen, Floats und Margins aufheben */
  /* Achtung: Die Klassen und IDs variieren von Theme zu Theme. Hier also eigene Klassen setzen */

  .bolded {
    page-break-after: always !important;
    page-break-inside: avoid !important;
  }

  .vue-grid-item {
    page-break-after: always !important;
    page-break-before: always !important;
  }

  .base-demo-print-area {
    page-break-inside: avoid !important;
  }

  /* .base-demo {
    page-break-before: avoid !important;
  } */

  .no-print,
  .no-print * {
    display: none !important;
  }

  .plus {
    display: none;
  }

  /* p {
    break-inside: avoid;
  } */
}
</style>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
  cursor: pointer;
}

.bolded {
  font-size: 16px;
  text-decoration: underline;
  font-weight: bolder;
  margin-left: 5px;
}

.text {
  /* background-color: blue; */
  text-align: justify;
  text-justify: inter-word;
}
.item-data {
  font-size: 13px;
  margin-left: 7px;
  margin-right: 7px;
}

.active {
  color: darkblue;
  text-decoration: underline;
  cursor: pointer;
}

.notconfirmed {
  background-color: yellow;
}

.flex-container {
  /* text-align: justify; */
  /* text-justify: inter-word; */
  display: inline;
  /* flex-wrap: wrap; */
  gap: 10px;
}

.flex-child {
  display: inline-block;
  margin: 5px;
  font-size: 12px;
  /* height: 80px; */
  /* margin: 10px; Magic! */
}

.droppable-element {
  width: 150px;
  text-align: center;
  border: 1px solid black;
  /* margin: 10px 0; */
  padding: 10px;
}
.coloured {
  background-color: #fdd;
}
.cursor-wait {
  cursor: wait;
}
.vue-grid-item-draggover {
  border: 1px solid #68a0f3;
  background-color: rgb(158, 247, 166);
}

/* @page {
  size: A4;
  margin: 0;
} */
</style>
